module.exports = __webpack_public_path__ + "img/myTeam_no_data.565463c3.png";